<template>
	<div class="content">
		<div v-if="rendered">
			<div class="row">
				<div class="col-lg-6">
					<div class="card eletricGreenBg text-center p-5">
						<h2>TRIBO TERRA</h2>
						<h2>
							<b>{{ pontosGrupo1 }} pontos</b>
						</h2>
					</div>
				</div>
				<div class="col-lg-6">
					<div class="card violetPurpleBg text-center p-5">
						<h2 class="text-white">TRIBO ÁGUA</h2>
						<h2 class="text-white">
							<b>{{ pontosGrupo2 }} pontos</b>
						</h2>
					</div>
				</div>
			</div>
			<div class="row mt-5" v-if="admin">
				<div class="col text-left">
					<div
						class="marineBg d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
					>
						<h2 class="mt-0 mb-0">Classificação</h2>
					</div>
					<div
						class="card card-subcategories card-plain tabs-classificacao pb-0"
					>
						<tabs
							class="p-0"
							type="success"
							tabContentClasses="tab-subcategories"
							square
							centered
						>
							<tab-pane>
								<span slot="label">
									<h3 class="mb-5 mt-5 text-white">Geral</h3>
								</span>
								<div v-if="verificarLength(geral)">
									<div class="row text-left">
										<div
											class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap p-3"
										>
											<el-select
												class="select-primary mb-3 pagination-select"
												v-model="paginationTG.perPage"
												placeholder="Paginação"
											>
												<el-option
													class="select-primary"
													v-for="item in paginationTG.perPageOptions"
													:key="item"
													:label="item"
													:value="item"
												>
												</el-option>
											</el-select>
											<base-input>
												<el-input
													type="search"
													class="mb-3 search-input"
													clearable
													prefix-icon="el-icon-search"
													placeholder="Pesquisar"
													v-model="searchQueryTG"
													aria-controls="datatables"
												>
												</el-input>
											</base-input>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<el-table :data="queriedDataTG" class="mb-3">
												<el-table-column
													:sort-method="ordenar"
													min-width="200"
													label="Nome"
												>
													<div slot-scope="props">
														{{ props.row.nome }}
													</div>
												</el-table-column>
												<el-table-column
													:sort-method="ordenar"
													min-width="200"
													label="Email"
												>
													<div slot-scope="props">
														{{ props.row.email }}
													</div>
												</el-table-column>
												<el-table-column
													:sort-method="ordenar"
													min-width="200"
													label="Tribo"
												>
													<div slot-scope="props">
														{{
															props.row.grupo == "0"
																? "Sem tribo"
																: props.row.grupo == "1"
																? "Tribo terra"
																: "Tribo água"
														}}
													</div>
												</el-table-column>
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Pontos"
												>
													<div slot-scope="props">
														{{ props.row.pontosFinais }}
													</div>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									<div class="col">
										<div class="card">
											<div class="p-5">
												<p>
													Ainda não existem participações concluidas suficientes
													para exibir as classificações
												</p>
											</div>
										</div>
									</div>
								</div>
							</tab-pane>
							<tab-pane>
								<span slot="label">
									<h3 class="mb-5 mt-5">Tribo Terra</h3>
								</span>
								<div v-if="verificarLength(tribo1)">
									<div class="row text-left">
										<div
											class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap p-3"
										>
											<el-select
												class="select-primary mb-3 pagination-select"
												v-model="paginationT1.perPage"
												placeholder="Paginação"
											>
												<el-option
													class="select-primary"
													v-for="item in paginationT1.perPageOptions"
													:key="item"
													:label="item"
													:value="item"
												>
												</el-option>
											</el-select>
											<base-input>
												<el-input
													type="search"
													class="mb-3 search-input"
													clearable
													prefix-icon="el-icon-search"
													placeholder="Pesquisar"
													v-model="searchQueryT1"
													aria-controls="datatables"
												>
												</el-input>
											</base-input>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<el-table :data="queriedDataT1" class="mb-3">
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Nome"
												>
													<div slot-scope="props">
														{{ props.row.nome }}
													</div>
												</el-table-column>
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Email"
												>
													<div slot-scope="props">
														{{ props.row.email }}
													</div>
												</el-table-column>
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Pontos"
												>
													<div slot-scope="props">
														{{ props.row.pontosFinais }}
													</div>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									<div class="col">
										<div class="card">
											<div class="p-5">
												<p>
													Ainda não existem participações concluidas suficientes
													para exibir as classificações
												</p>
											</div>
										</div>
									</div>
								</div>
							</tab-pane>

							<tab-pane>
								<span slot="label" class="tribo2">
									<h3 class="mb-5 mt-5 text-white">Tribo Água</h3>
								</span>
								<div v-if="verificarLength(tribo2)">
									<div class="row text-left">
										<div
											class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap p-3"
										>
											<el-select
												class="select-primary mb-3 pagination-select"
												v-model="paginationT2.perPage"
												placeholder="Paginação"
											>
												<el-option
													class="select-primary"
													v-for="item in paginationT2.perPageOptions"
													:key="item"
													:label="item"
													:value="item"
												>
												</el-option>
											</el-select>
											<base-input>
												<el-input
													type="search"
													class="mb-3 search-input"
													clearable
													prefix-icon="el-icon-search"
													placeholder="Pesquisar"
													v-model="searchQueryT2"
													aria-controls="datatables"
												>
												</el-input>
											</base-input>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<el-table :data="queriedDataT2" class="mb-3">
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Nome"
												>
													<div slot-scope="props">
														{{ props.row.nome }}
													</div>
												</el-table-column>
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Email"
												>
													<div slot-scope="props">
														{{ props.row.email }}
													</div>
												</el-table-column>
												<el-table-column
													sortable
													:sort-method="ordenar"
													min-width="200"
													label="Pontos"
												>
													<div slot-scope="props">
														{{ props.row.pontosFinais }}
													</div>
												</el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									<div class="col">
										<div class="card">
											<div class="p-5">
												<p>
													Ainda não existem participações concluidas suficientes
													para exibir as classificações
												</p>
											</div>
										</div>
									</div>
								</div>
							</tab-pane>
						</tabs>
					</div>
				</div>
			</div>
			<div class="card marineBg titulo p-5 mt-5" v-if="admin">
				<div class="row">
					<div class="col text-left">
						<h2>Filtrar por atividade</h2>
					</div>
					<div class="col text-right">
						<base-button
							@click="limparFiltros()"
							class="mb-3 bg_edp_verde"
							size="lg"
							simple
						>
							Limpar Filtros
						</base-button>
					</div>
				</div>
				<div class="row mt-5">
					<div class="col-6">
						<h3 class="text-left">Tribo Terra</h3>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="10 Horas"
								v-model="escolhidoGrupo1_10"
								@change="filtrarTabela('1', '10')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo1_10"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="11 Horas"
								v-model="escolhidoGrupo1_11"
								@change="filtrarTabela('1', '11')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo1_11"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="12 Horas"
								v-model="escolhidoGrupo1_12"
								@change="filtrarTabela('1', '12')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo1_12"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="col-6">
						<h3 class="text-left">Tribo Água</h3>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="10 Horas"
								v-model="escolhidoGrupo2_10"
								@change="filtrarTabela('2', '10')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo2_10"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="11 Horas"
								v-model="escolhidoGrupo2_11"
								@change="filtrarTabela('2', '11')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo2_11"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
						<div class="row">
							<el-select
								class="select-primary mb-3 pagination-select"
								placeholder="12 Horas"
								v-model="escolhidoGrupo2_12"
								@change="filtrarTabela('2', '12')"
							>
								<el-option
									class="select-primary"
									v-for="(item, i) in atividadesGrupo2_12"
									:key="i"
									:label="item.nome + ' - ' + item.hora + 'h'"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="filtrado1 || filtrado2">
				<div class="col">
					<el-table :data="tableData">
						<el-table-column
							sortable
							:sort-method="ordenar"
							width="200"
							label="Nome"
						>
							<div slot-scope="props">
								{{ props.row.nome }}
							</div>
						</el-table-column>
						<el-table-column
							sortable
							:sort-method="ordenar"
							width="100"
							label="Tribo"
						>
							<div slot-scope="props">
								{{
									props.row.grupo == "0"
										? "Sem tribo"
										: props.row.grupo == "1"
										? "Tribo terra"
										: "Tribo água"
								}}
							</div>
						</el-table-column>
						<el-table-column
							sortable
							:sort-method="ordenar"
							:min-width="150"
							label="Email"
						>
							<div slot-scope="props">
								<div>{{ props.row.email }}</div>
							</div>
						</el-table-column>
						<el-table-column
							sortable
							:sort-method="ordenar"
							:min-width="150"
							label="Presente?"
						>
							<div slot-scope="props">
								<div>{{ presenca(props.row) }}</div>
							</div>
						</el-table-column>
						<el-table-column
							sortable
							:sort-method="ordenar"
							:min-width="150"
							label="Pontos"
						>
							<div slot-scope="props">
								<div>{{ pontos(props.row) }}</div>
							</div>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="row mt-5" v-if="admin">
				<div class="col text-left">
					<div
						class="marineBg d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
					>
						<h2 class="mt-0 mb-0">
							Concorrentes inscritos - Total
							<b>{{ this.tableDataInscritos.length }}</b>
						</h2>
					</div>
					<div class="card">
						<div
							class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap p-3"
						>
							<el-select
								class="select-primary mb-3 pagination-select"
								v-model="pagination.perPage"
								placeholder="Paginação"
							>
								<el-option
									class="select-primary"
									v-for="item in pagination.perPageOptions"
									:key="item"
									:label="item"
									:value="item"
								>
								</el-option>
							</el-select>

							<base-input>
								<el-input
									type="search"
									class="mb-3 search-input"
									clearable
									prefix-icon="el-icon-search"
									placeholder="Pesquisar"
									v-model="searchQuery"
									aria-controls="datatables"
								>
								</el-input>
							</base-input>
						</div>
						<el-table :data="queriedData">
							<el-table-column
								sortable
								:sort-method="ordenar"
								width="200"
								label="Nome"
							>
								<div slot-scope="props">
									{{ props.row.nome }}
								</div>
							</el-table-column>
							<el-table-column
								sortable
								:sort-method="ordenar"
								width="100"
								label="Tribo"
							>
								<div slot-scope="props">
									{{
										props.row.grupo == "0"
											? "Sem tribo"
											: props.row.grupo == "1"
											? "Tribo terra"
											: "Tribo água"
									}}
								</div>
							</el-table-column>
							<el-table-column
								sortable
								:sort-method="ordenar"
								:min-width="150"
								label="Atividade 10h"
							>
								<div slot-scope="props">
									<!-- SECURITY COMMENT <div v-html="props.row.atividade1"></div> -->
									<div>{{ props.row.atividade1 }}</div>
								</div>
							</el-table-column>
							<el-table-column
								sortable
								:sort-method="ordenar"
								:min-width="150"
								label="Atividades 11h"
							>
								<div slot-scope="props">
									<!-- SECURITY COMMENT <div v-html="props.row.atividade2"></div> -->
									<div>{{ props.row.atividade2 }}</div>
								</div>
							</el-table-column>
							<el-table-column
								sortable
								:sort-method="ordenar"
								:min-width="150"
								label="Atividades 12h"
							>
								<div slot-scope="props">
									<!-- SECURITY COMMENT <div v-html="props.row.atividade3"></div> -->
									<div>
										{{ props.row.atividade3 }}
									</div>
								</div>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api from "@/api/index";
	import Fuse from "fuse.js";
	import {
		Card,
		BaseProgress,
		BasePagination,
		Modal,
		TabPane,
		Tabs,
		BaseInput,
	} from "@/components/index";
	import { Table, TableColumn } from "element-ui";
	export default {
		components: {
			TabPane,
			Tabs,
			Card,
			Modal,
			BaseProgress,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			BasePagination,
			BaseInput,
		},
		data() {
			return {
				admin: false,

				filtrado1: false,
				filtrado2: false,
				atividadesGrupo1_10: [],
				atividadesGrupo2_10: [],
				atividadesGrupo1_11: [],
				atividadesGrupo2_11: [],
				atividadesGrupo1_12: [],
				atividadesGrupo2_12: [],
				escolhidoGrupo1_10: "",
				escolhidoGrupo2_10: "",
				escolhidoGrupo1_11: "",
				escolhidoGrupo2_11: "",
				escolhidoGrupo1_12: "",
				escolhidoGrupo2_12: "",
				filtrado1: false,
				filtrado2: false,

				informacaoUtilizadores: [],
				informacaoUtilizadoresBU: [],
				tribo1: [],
				tribo2: [],
				geral: [],
				utilizador: [],
				atividades: [],
				tableData: [],
				tableDataBU: [],

				tableDataInscritos: [],
				tableDataInscritosBU: [],
				rendered: false,
				show: true,
				pontosGrupo1: 0,
				pontosGrupo2: 0,

				//TABLE GERAL
				paginationTG: {
					perPage: 5,
					currentPage: 1,
					perPageOptions: [50, 100, 200, 400, 600],
					total: 0,
				},
				searchQueryTG: "",
				propsToSearchTG: ["nome", "email", "grupo", "pontosFinais"],
				searchedDataTG: [],

				//TABLE TRIBO TERRA
				paginationT1: {
					perPage: 5,
					currentPage: 1,
					perPageOptions: [50, 100, 200, 400, 600],
					total: 0,
				},
				searchQueryT1: "",
				propsToSearchT1: ["nome", "email", "pontosFinais"],
				searchedDataT1: [],

				//TABLE TRIBO ÁGUA
				paginationT2: {
					perPage: 5,
					currentPage: 1,
					perPageOptions: [50, 100, 200, 400, 600],
					total: 0,
				},

				searchQueryT2: "",
				propsToSearchT2: ["nome", "email", "pontosFinais"],
				searchedDataT2: [],

				// TABLE PAGINAÇÃO MAIS PESQUISA INSCRITOS//
				pagination: {
					perPage: 50,
					currentPage: 1,
					perPageOptions: [50, 100, 200, 400, 600],
					total: 0,
				},
				searchQuery: "",
				propsToSearch: ["nome", "atividade1", "atividade2", "atividade3"],
				searchedData: [],
				fuseSearch: null,
				//  FIM //
			};
		},
		methods: {
			verificarLength(array) {
				var temp = array.filter((x) => x.registo);
				if (temp.length >= 1) {
					return true;
				}
				return false;
			},
			limparFiltros() {
				this.escolhidoGrupo1_10 = "";
				this.escolhidoGrupo1_11 = "";
				this.escolhidoGrupo1_12 = "";
				this.escolhidoGrupo2_10 = "";
				this.escolhidoGrupo2_11 = "";
				this.escolhidoGrupo2_12 = "";
				this.filtrado1 = false;
				this.filtrado2 = false;
			},
			presenca(array) {
				// escolhidoGrupo1_10: "",
				// escolhidoGrupo2_10: "",
				// escolhidoGrupo1_11: "",
				// escolhidoGrupo2_11: "",
				// escolhidoGrupo1_12: "",
				// escolhidoGrupo2_12: "",
				if (this.escolhidoGrupo1_10 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_10)
						.presenca == "nao"
						? "Não"
						: "Sim";
				} else if (this.escolhidoGrupo2_10 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_10)
						.presenca == "nao"
						? "Não"
						: "Sim";
				} else if (this.escolhidoGrupo1_11 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_11)
						.presenca == "nao"
						? "Não"
						: "Sim";
				} else if (this.escolhidoGrupo2_11 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_11)
						.presenca == "nao"
						? "Não"
						: "Sim";
				} else if (this.escolhidoGrupo1_12 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_12)
						.presenca == "nao"
						? "Não"
						: "Sim";
				} else if (this.escolhidoGrupo2_12 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_12)
						.presenca == "nao"
						? "Não"
						: "Sim";
				}
			},
			pontos(array) {
				if (this.escolhidoGrupo1_10 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_10)
						.pontos;
				} else if (this.escolhidoGrupo2_10 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_10)
						.pontos;
				} else if (this.escolhidoGrupo1_11 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_11)
						.pontos;
				} else if (this.escolhidoGrupo2_11 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_11)
						.pontos;
				} else if (this.escolhidoGrupo1_12 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo1_12)
						.pontos;
				} else if (this.escolhidoGrupo2_12 != "") {
					return array.desempenho.find((x) => x.id == this.escolhidoGrupo2_12)
						.pontos;
				}
			},
			filtrarTabela(grupo, hora) {
				if (grupo == "1") {
					this.escolhidoGrupo2_10 = "";
					this.escolhidoGrupo2_11 = "";
					this.escolhidoGrupo2_12 = "";
					if (hora == "10") {
						this.escolhidoGrupo1_11 = "";
						this.escolhidoGrupo1_12 = "";
					} else if (hora == "11") {
						this.escolhidoGrupo1_10 = "";
						this.escolhidoGrupo1_12 = "";
					} else {
						this.escolhidoGrupo1_11 = "";
						this.escolhidoGrupo1_10 = "";
					}

					if (this.escolhidoGrupo1_10 != "") {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo1_10.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = false;
							this.filtrado1 = true;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					} else if (this.escolhidoGrupo1_11 != "") {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo1_11.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = false;
							this.filtrado1 = true;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					} else {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo1_12.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = false;
							this.filtrado1 = true;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					}
				} else {
					this.escolhidoGrupo1_10 = "";
					this.escolhidoGrupo1_11 = "";
					this.escolhidoGrupo1_12 = "";

					if (hora == "10") {
						this.escolhidoGrupo2_11 = "";
						this.escolhidoGrupo2_12 = "";
					} else if (hora == "11") {
						this.escolhidoGrupo2_10 = "";
						this.escolhidoGrupo2_12 = "";
					} else {
						this.escolhidoGrupo2_11 = "";
						this.escolhidoGrupo2_10 = "";
					}

					if (this.escolhidoGrupo2_10 != "") {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo2_10.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = true;
							this.filtrado1 = false;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					} else if (this.escolhidoGrupo2_11 != "") {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo2_11.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = true;
							this.filtrado1 = false;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					} else {
						this.tableData = this.tableDataBU.filter(
							(x) =>
								x.atividades
									.split(",")
									.indexOf(this.escolhidoGrupo2_12.toString()) > -1 && x.registo
						);
						if (this.tableData.length > 0) {
							this.filtrado2 = true;
							this.filtrado1 = false;
						} else {
							this.filtrado2 = false;
							this.filtrado1 = false;
							this.naoEncontrado = true;
						}
					}
				}
			},
			ordenar: function(a, b) {
				return a.value > b.value ? -1 : 1;
			},
			async inicio() {
				//buscar atividades
				var jsonGrupo1 = {
					grupo: "1",
				};
				var jsonGrupo2 = {
					grupo: "2",
				};
				let resultadoAtividadesGrupo1 = await api.buscarAtividadesGrupo(
					jsonGrupo1
				);
				let resultadoAtividadesGrupo2 = await api.buscarAtividadesGrupo(
					jsonGrupo2
				);

				resultadoAtividadesGrupo1 = Object.values(resultadoAtividadesGrupo1);
				resultadoAtividadesGrupo2 = Object.values(resultadoAtividadesGrupo2);

				this.atividadesGrupo1_10 = resultadoAtividadesGrupo1.filter(
					(x) => x.hora == "10"
				);
				this.atividadesGrupo2_10 = resultadoAtividadesGrupo2.filter(
					(x) => x.hora == "10"
				);
				this.atividadesGrupo1_11 = resultadoAtividadesGrupo1.filter(
					(x) => x.hora == "11"
				);
				this.atividadesGrupo2_11 = resultadoAtividadesGrupo2.filter(
					(x) => x.hora == "11"
				);
				this.atividadesGrupo1_12 = resultadoAtividadesGrupo1.filter(
					(x) => x.hora == "12"
				);
				this.atividadesGrupo2_12 = resultadoAtividadesGrupo2.filter(
					(x) => x.hora == "12"
				);
				// buscar utilizadores
				let resultadoUtilizadores = await api.buscarDadosTodos();
				resultadoUtilizadores = Object.values(resultadoUtilizadores);
				this.utilizadores = resultadoUtilizadores;
				for (let i = 0; i < this.utilizadores.length; i++) {
					var temp3 = this.utilizadores[i].atividades.split(",");
					this.utilizadores[i].pontosFinais = 0;
					var temp = [];
					var pontos = [];
					if (
						this.utilizadores[i].pontos != null &&
						this.utilizadores[i].pontos != ""
					) {
						pontos = this.utilizadores[i].pontos;
					} else {
						this.utilizadores[i].pontos = [];

						var temp2 = {};
						for (let k = 0; k < temp3.length; k++) {
							temp2[temp3[k]] = { pontos: "0", presente: "nao" };
						}
						this.utilizadores[i].pontos = JSON.stringify(temp2);
					}

					if (this.utilizadores[i].grupo == "1" && pontos.length > 0) {
						temp = Object.values(JSON.parse(pontos));
						Object.keys(temp).map((j) => {
							this.utilizadores[i].pontosFinais += Number(temp[j].pontos);
							this.pontosGrupo1 += Number(temp[j].pontos);
						});
					}
					if (this.utilizadores[i].grupo == "2" && pontos.length > 0) {
						temp = Object.values(JSON.parse(pontos));
						Object.keys(temp).map((j) => {
							this.utilizadores[i].pontosFinais += Number(temp[j].pontos);
							this.pontosGrupo2 += Number(temp[j].pontos);
						});
					}
				}

				let resultadoAtividades = await api.buscarAtividades();

				resultadoAtividades = Object.values(resultadoAtividades);
				this.atividades = resultadoAtividades;
				var tableDataInscritos = [];
				for (let i = 0; i < this.utilizadores.length; i++) {
					var tempAtividades = this.utilizadores[i].atividades.split(",");
					if (this.utilizadores[i].atividades.length > 0) {
						for (let k = 0; k < tempAtividades.length; k++) {
							if (tempAtividades[k] != "" && tempAtividades[k]) {
								if (
									this.atividades.find((x) => x.id == tempAtividades[k]).hora ==
									"10"
								) {
									this.utilizadores[i].atividade1 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).nome;
									this.utilizadores[i].hora1 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).hora;
								} else if (
									this.atividades.find((x) => x.id == tempAtividades[k]).hora ==
									"11"
								) {
									this.utilizadores[i].atividade2 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).nome;
									this.utilizadores[i].hora2 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).hora;
								} else if (
									this.atividades.find((x) => x.id == tempAtividades[k]).hora ==
									"12"
								) {
									this.utilizadores[i].atividade3 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).nome;
									this.utilizadores[i].hora3 = this.atividades.find(
										(x) => x.id == tempAtividades[k]
									).hora;
								}
							}
						}
						if (tempAtividades != "" && tempAtividades) {
							tableDataInscritos.push(this.utilizadores[i]);
						}
						if (
							this.utilizadores[i].pontos != "" &&
							this.utilizadores[i].pontos
						) {
						}
					}
					if (!this.utilizadores[i].atividade1) {
						this.utilizadores[i].atividade1 = "";
					}
					if (!this.utilizadores[i].atividade2) {
						this.utilizadores[i].atividade2 = "";
					}
					if (!this.utilizadores[i].atividade3) {
						this.utilizadores[i].atividade3 = "";
					}

					// TABELA DESEMPENHO
				}
				var grupo1Ordenado = this.utilizadores.filter(
					(x) => x.grupo == "1" && x.nivel == "3"
				);
				grupo1Ordenado = grupo1Ordenado.sort((a, b) => {
					return Number(a.pontosFinais) > Number(b.pontosFinais) ? -1 : 1;
				});
				var grupo2Ordenado = this.utilizadores.filter(
					(x) => x.grupo == "2" && x.nivel == "3"
				);
				grupo2Ordenado = grupo2Ordenado.sort((a, b) => {
					return Number(a.pontosFinais) > Number(b.pontosFinais) ? -1 : 1;
				});
				var geraOrdenado = this.utilizadores
					.filter((x) => x.nivel == "3" && x.grupo != "0")
					.sort((a, b) => {
						return Number(a.pontosFinais) > Number(b.pontosFinais) ? -1 : 1;
					});
				this.tribo1 = grupo1Ordenado;
				this.tribo2 = grupo2Ordenado;
				this.geral = geraOrdenado;
				this.tableDataInscritos = tableDataInscritos;
				this.tableDataInscritosBU = tableDataInscritos;

				for (let i = 0; i < this.utilizadores.length; i++) {
					var temp = this.utilizadores[i].atividades.split(",");
					this.utilizadores[i].desempenho = [];
					if (
						this.utilizadores[i].pontos != null &&
						this.utilizadores[i].pontos.length > 3
					) {
						this.utilizadores[i].pontos = JSON.parse(
							this.utilizadores[i].pontos
						);
						this.utilizadores[i].registo = true;
					} else {
						this.utilizadores[i].registo = false;
					}
					if (temp.length > 0) {
						for (let k = 0; k < temp.length; k++) {
							if (this.utilizadores[i].registo) {
								if (temp[k] && temp[k] != "") {
									var pontosAtividade = this.utilizadores[i].pontos[temp[k]]
										.pontos
										? this.utilizadores[i].pontos[temp[k]].pontos
										: "";
									var presencaAtividade = this.utilizadores[i].pontos[temp[k]]
										.presente
										? this.utilizadores[i].pontos[temp[k]].presente
										: "";

									var nomeAtividade = this.atividades.find(
										(x) => x.id == temp[k]
									).nome;
									var idAtividade = this.atividades.find((x) => x.id == temp[k])
										.id;

									this.utilizadores[i].desempenho.push({
										id: idAtividade,
										nome: nomeAtividade,
										presenca: presencaAtividade,
										pontos: pontosAtividade,
									});
								} else {
									this.utilizadores[i].desempenho.push({
										id: "",
										nome: "",
										presenca: "",
										pontos: "",
									});
								}
							}
						}
					}
				}
				this.tableData = this.utilizadores;
				this.tableDataBU = this.utilizadores;
			},
		},
		computed: {
			// TABELA GERAL

			queriedDataTG() {
				if (!this.searchQueryTG || this.searchQueryTG == "") {
					return this.geral.slice(this.fromTG, this.toTG);
				}
				if (
					this.searchQueryTG.toLowerCase() == "água" ||
					this.searchQueryTG.toLowerCase() == "agua"
				) {
					return this.geral.filter((x) => x.grupo == "2");
				}
				if (this.searchQueryTG.toLowerCase() == "terra") {
					return this.geral.filter((x) => x.grupo == "1");
				}
				let result = this.geral.filter((row) => {
					let isIncluded = false;
					for (let key of this.propsToSearchTG) {
						let rowValue = row[key]
							.toString()
							.toLowerCase()
							.replaceAll(" ", "")
							.replaceAll("ã", "a")
							.replaceAll("á", "a")
							.replaceAll("à", "a")
							.replaceAll("é", "e")
							.replaceAll("è", "e")
							.replaceAll("ó", "o")
							.replaceAll("í", "i");
						if (
							rowValue.includes &&
							rowValue.includes(
								this.searchQueryTG
									.toLowerCase()
									.replaceAll(" ", "")
									.replaceAll("ã", "a")
									.replaceAll("á", "a")
									.replaceAll("à", "a")
									.replaceAll("é", "e")
									.replaceAll("è", "e")
									.replaceAll("ó", "o")
									.replaceAll("í", "i")
							)
						) {
							isIncluded = true;
						}
					}
					return isIncluded;
				});
				return result.slice(this.fromTG, this.toTG);
			},
			toTG() {
				let highBound = this.fromTG + this.paginationTG.perPage;
				if (this.totalTG < highBound) {
					highBound = this.totalTG;
				}
				return highBound;
			},
			fromTG() {
				return this.paginationTG.perPage * (this.paginationTG.currentPage - 1);
			},
			totalTG() {
				return this.searchedDataTG.length > 0
					? this.searchedDataTG.length
					: this.geral.length;
			},

			//TABELA TRIBO TERRA
			queriedDataT1() {
				if (!this.searchQueryT1 || this.searchQueryT1 == "") {
					return this.tribo1.slice(this.fromT1, this.toT1);
				}
				let result = this.tribo1.filter((row) => {
					let isIncluded = false;
					for (let key of this.propsToSearchT1) {
						let rowValue = row[key]
							.toString()
							.toLowerCase()
							.replaceAll(" ", "")
							.replaceAll("ã", "a")
							.replaceAll("á", "a")
							.replaceAll("à", "a")
							.replaceAll("é", "e")
							.replaceAll("è", "e")
							.replaceAll("ó", "o")
							.replaceAll("í", "i");
						if (
							rowValue.includes &&
							rowValue.includes(
								this.searchQueryT1
									.toLowerCase()
									.replaceAll(" ", "")
									.replaceAll("ã", "a")
									.replaceAll("á", "a")
									.replaceAll("à", "a")
									.replaceAll("é", "e")
									.replaceAll("è", "e")
									.replaceAll("ó", "o")
									.replaceAll("í", "i")
							)
						) {
							isIncluded = true;
						}
					}
					return isIncluded;
				});
				return result.slice(this.fromT1, this.toT1);
			},
			toT1() {
				let highBound = this.fromT1 + this.paginationT1.perPage;
				if (this.totalT1 < highBound) {
					highBound = this.totalT1;
				}
				return highBound;
			},
			fromT1() {
				return this.paginationT1.perPage * (this.paginationT1.currentPage - 1);
			},
			totalT1() {
				return this.searchedDataT1.length > 0
					? this.searchedDataT1.length
					: this.tribo1.length;
			},

			//TABELA TRIBO ÁGUA
			queriedDataT2() {
				if (!this.searchQueryT2 || this.searchQueryT2 == "") {
					return this.tribo2.slice(this.fromT2, this.toT2);
				}
				let result = this.tribo2.filter((row) => {
					let isIncluded = false;
					for (let key of this.propsToSearchT2) {
						let rowValue = row[key]
							.toString()
							.toLowerCase()
							.replaceAll(" ", "")
							.replaceAll("ã", "a")
							.replaceAll("á", "a")
							.replaceAll("à", "a")
							.replaceAll("é", "e")
							.replaceAll("è", "e")
							.replaceAll("ó", "o")
							.replaceAll("í", "i");
						if (
							rowValue.includes &&
							rowValue.includes(
								this.searchQueryT2
									.toLowerCase()
									.replaceAll(" ", "")
									.replaceAll("ã", "a")
									.replaceAll("á", "a")
									.replaceAll("à", "a")
									.replaceAll("é", "e")
									.replaceAll("è", "e")
									.replaceAll("ó", "o")
									.replaceAll("í", "i")
							)
						) {
							isIncluded = true;
						}
					}
					return isIncluded;
				});
				return result.slice(this.fromT2, this.toT2);
			},
			toT2() {
				let highBound = this.fromT2 + this.paginationT2.perPage;
				if (this.totalT2 < highBound) {
					highBound = this.totalT2;
				}
				return highBound;
			},
			fromT2() {
				return this.paginationT2.perPage * (this.paginationT2.currentPage - 1);
			},
			totalT2() {
				return this.searchedDataT2.length > 0
					? this.searchedDataT2.length
					: this.tribo2.length;
			},

			// TABELA INSCRITOS
			queriedData() {
				if (!this.searchQuery || this.searchQuery == "") {
					return this.tableDataInscritos.slice(this.from, this.to);
				}
				let result = this.tableDataInscritos.filter((row) => {
					let isIncluded = false;
					for (let key of this.propsToSearch) {
						let rowValue = row[key]
							.toString()
							.toLowerCase()
							.replaceAll(" ", "")
							.replaceAll("ã", "a")
							.replaceAll("á", "a")
							.replaceAll("à", "a")
							.replaceAll("é", "e")
							.replaceAll("è", "e")
							.replaceAll("ó", "o")
							.replaceAll("í", "i");
						if (
							rowValue.includes &&
							rowValue.includes(
								this.searchQuery
									.toLowerCase()
									.replaceAll(" ", "")
									.replaceAll("ã", "a")
									.replaceAll("á", "a")
									.replaceAll("à", "a")
									.replaceAll("é", "e")
									.replaceAll("è", "e")
									.replaceAll("ó", "o")
									.replaceAll("í", "i")
							)
						) {
							isIncluded = true;
						}
					}
					return isIncluded;
				});
				return result.slice(this.from, this.to);
			},
			to() {
				let highBound = this.from + this.pagination.perPage;
				if (this.total < highBound) {
					highBound = this.total;
				}
				return highBound;
			},
			from() {
				return this.pagination.perPage * (this.pagination.currentPage - 1);
			},
			total() {
				return this.searchedData.length > 0
					? this.searchedData.length
					: this.tableDataInscritos.length;
			},
		},
		async mounted() {
			var user_id = localStorage.getItem("active-session-niu");
			var jsonUser = {
				user_id: user_id,
			};
			let res = await api.buscarDados(jsonUser);
			var user = Object.values(res)[0];
			// if (user.nivel != "1") {
			//   if (user.pontos && user.pontos.length > 4) {
			//     if (user.nivel == "2") {
			//       this.$router.push("/promotor");
			//     } else if (user.nivel == "3") {
			//       this.$router.push("/atividades");
			//     }
			//     return;
			//   }

			// }
			if (user.nivel == "1") {
				this.admin = true;
			}
			await this.inicio();
			this.rendered = true;
			this.show = false;
		},
	};
</script>

<style>
	/* . {
    margin-top: 5rem !important;
  } */
	.cardTribos {
		border-radius: 5px;
	}

	.podio {
		font-size: 48px;
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
	}
	.podio p {
		font-size: 16px;
	}

	.tabs-classificacao ul li.nav-item {
		width: 33%;
		padding: 0;
		margin: 0 !important;
	}

	.tabs-classificacao .col-12 {
		padding: 0;
	}

	.tabs-classificacao .nav-link {
		margin-top: 5px;
	}

	.tabs-classificacao .nav-item.active.numeroTab0 a {
		background: #7c9599 !important;
	}
	.tabs-classificacao .nav-item.active.numeroTab1 a {
		background: #28ff52 !important;
	}
	.tabs-classificacao .nav-item.active.numeroTab2 a {
		background: #6d32ff !important;
	}

	.nav-pills .nav-item .nav-link.active,
	.nav-pills .nav-item .nav-link.active:focus,
	.nav-pills .nav-item .nav-link.active:hover {
		box-shadow: 4px 5px 9px rgb(109, 109, 109);
	}

	.podio {
		box-shadow: none !important;
		background: #fff;
	}

	.podio h2,
	.podio p {
		text-align: center !important;
	}

	.tab-space {
		padding: 20px 0 0px 0px;
	}

	.el-table {
		background-color: #fff !important;
	}

	.tabs-classificacao .nav-link {
		height: 100%;
	}
</style>
